import CONFIG from '../config/config';
import { instanceWithV2 as APIClient } from './SimpleAPIClient';

export interface PaymentSplitDto {
  id?: number;
  amount: number;
  dueDate?: string;
  paymentMethod: 'TRANSFER' | 'CARD' | 'CASH';
  paid: boolean;
  paidDate?: string;
  invoiceReference?: string;
  updatedAt?: string;
}

export type ResourceType = 'Order' | 'Contract' | 'Booking' | 'Invoice';

export interface PaymentPlanDto {
  id?: number;
  resourceId: string;
  totalAmount: number;
  currency: string;
  description?: string;
  status: 'ACTIVE' | 'COMPLETED' | 'CANCELLED' | 'OVERDUE';
  paymentSplits: PaymentSplitDto[];
}

export interface CreatePaymentSplitRequest {
  amount: number;
  dueDate?: string;
  paymentMethod: 'TRANSFER' | 'CARD' | 'CASH';
  paid?: boolean;
  paidDate?: string; // ISO date-time string
  invoiceReference?: string;
}

export interface CreatePaymentPlanRequest {
  resourceType?: ResourceType;
  totalAmount: number;
  currency: string;
  description?: string;
  paymentSplits: CreatePaymentSplitRequest[];
}

export interface UpdatePaymentSplitRequest {
  id?: number;
  amount: number;
  dueDate?: string;
  paymentMethod: 'TRANSFER' | 'CARD' | 'CASH';
  paid: boolean;
  paidDate?: string; // ISO date-time string
  invoiceReference?: string;
}

export interface UpdatePaymentPlanRequest {
  totalAmount: number;
  currency: string;
  description?: string;
  paymentSplits: UpdatePaymentSplitRequest[];
}

export interface DefaultPaymentPlanData {
  itemName: string;
  price: number;
  currency: string;
}

const PaymentPlansAPI = {
  getPaymentPlan: (orderId: string) => APIClient(CONFIG.API_ENDPOINT).get<PaymentPlanDto>(`/v1/shops/orders/${orderId}/payment-plan`),
  getDefaultPaymentPlanData: (orderId: string) => APIClient(CONFIG.API_ENDPOINT).get<DefaultPaymentPlanData>(`/v1/shops/orders/${orderId}/payment-plan/default`),
  createPaymentPlan: (orderId: string, request: CreatePaymentPlanRequest) => APIClient(CONFIG.API_ENDPOINT).post<PaymentPlanDto>(`/v1/shops/orders/${orderId}/payment-plan`, request),
  updatePaymentPlan: (orderId: string, request: UpdatePaymentPlanRequest) => APIClient(CONFIG.API_ENDPOINT).put<PaymentPlanDto>(`/v1/shops/orders/${orderId}/payment-plan`, request),
  deletePaymentPlan: (orderId: string) => APIClient(CONFIG.API_ENDPOINT).delete(`/v1/shops/orders/${orderId}/payment-plan`)
};

export default PaymentPlansAPI; 